import validateSpanishId from './rules/validateSpanishId';
import validateIBAN from './rules/validateIBAN';
import validateClientAge from './rules/validateDates';

const regexPhone = /^([9,7,6]{1})+([0-9]{8})$/;
const regexZipCode = /0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}/;

const validators = Validator => {
  // Phone
  Validator.extend('phone', value => regexPhone.test(value) && value.length === 9);

  // Zip code
  Validator.extend('zip_code', value => regexZipCode.test(value) && value.length === 5);

  // DNI
  Validator.extend('dni', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'dni' && valid;
  });

  // NIE
  Validator.extend('nie', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'nie' && valid;
  });

  // CIF
  Validator.extend('cif', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'cif' && valid;
  });

  // Document Number (DNI or NIE)
  Validator.extend('document_number', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return (type === 'dni' || type === 'nie') && valid;
  });

  // IBAN
  Validator.extend('iban', value => validateIBAN(value));

  // Client older than or equal to 25 years
  Validator.extend('client_age_ge', (value, ageThreshold) =>
    validateClientAge('ge', value, ageThreshold)
  );
};

export { validators as default };
